import { useFormik } from 'formik';
import { useAuth } from "../../components/auth"
import { loginValidationSchema } from './validationSchema';
import { LoginFrom } from './type';
import { Row, Col, Label, Button, FormFeedback, Spinner, FormGroup, Input, Alert } from 'reactstrap'

import { Link, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useLoaderHelper } from '../../helper/loaderHelper';

import { qboButton, qboLogo, xero, zohoLogo } from '../../constant/icons';
import { connectToAPP } from '../company/helper';
import { useEffect, useState } from 'react';
import { message } from '../../components/toast';
import { get, post } from '../../helper/api';
import { close } from '../../constant/icons';

const initialValues: LoginFrom = {
  userName: "",
  password: "",
  acceptTerms: false,
}

const Login = () => {
  const location = useLocation()
  const auth = useAuth()
  const navigate = useNavigate();
  let loginType: string | undefined | null = location.pathname.split('/')[1]
  const [zohoRegion, setZohoRegion] = useState("IN"); // ✅ India default
  if (!['odoo', "QBO", "xero", "zoho", "qbo"].includes(loginType)) {
    loginType = undefined
  }


  if (loginType === "qbo") {
    loginType = "QBO"
  }
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get('token');
  const userName = searchParams.get('userName');
  const role = searchParams.get('role');
  const [xeroCofig, setXeroCofig] = useState({
    YOUR_REQUEST_STATE: "check",
    YOUR_CALLBACK_URL: "check",
    YOUR_CLIENT_ID: "check"
  })
  console.log({ token, userName, role })
  const { api, dbName, user_name, hostingUrl } = useParams();
  if (loginType && token && userName && role) {
    auth.singleSignOn({
      "token": token,
      "userName": userName,
      "role": role,
      "loginType": loginType
    })
  }
  const errorMsg: any = searchParams.get('errorMsg');
  useEffect(() => {
    if (loginType === "xero") {
      get("/xeroValues").then((xeroConfig: any) => {
        setXeroCofig({
          YOUR_CALLBACK_URL: xeroConfig.YOUR_CALLBACK_URL,
          YOUR_CLIENT_ID: xeroConfig.YOUR_CLIENT_ID,
          YOUR_REQUEST_STATE: xeroConfig.YOUR_REQUEST_STATE
        });

        // ✅ Avoid multiple loads
        const scriptUrl = 'https://edge.xero.com/platform/sso/xero-sso.js';
        const alreadyLoaded = !!document.querySelector(`script[src="${scriptUrl}"]`);

        if (!alreadyLoaded && !customElements.get('xero-sso')) {
          const script = document.createElement('script');
          script.src = scriptUrl;
          script.async = true;
          script.defer = true;
          document.body.appendChild(script);
        }

      }).catch((err) => {
        console.error("Failed to fetch xero config:", err);
      });
    }
  }, [loginType]); // ✅ depend on loginType if it's dynamic

  useEffect(() => {
    if (errorMsg) {
      message(
        "error",
        errorMsg
      );
      const timer = setTimeout(() => {
        navigate("/QBO/login");
      }, 3000); // 3 seconds in milliseconds
      return () => clearTimeout(timer);

    }
  }, [errorMsg]);

  const singInWithOdoo = async () => {

    if (api && dbName && user_name && hostingUrl) {
      let result = await post("/odooLogin", {
        api, dbName, user_name, hostingUrl
      })
    }
  }

  let icon = ""
  if (loginType) {
    if (loginType == "xero") {
      icon = xero.icon
    } else if (loginType == "QBO") {
      icon = qboButton.icon
    }
    else if (loginType == "zoho") {
      icon = zohoLogo.icon
    }
    else if (loginType == "odoo") {
      icon = zohoLogo.icon
      singInWithOdoo()
    }
  }

  const loading = useLoaderHelper()
  const loading2 = useLoaderHelper()
  const loginFrom = useFormik({
    initialValues: initialValues,
    validationSchema: loginValidationSchema,
    onSubmit: async values => {
      if (window.sessionStorage.getItem("token")) {
        window.location.reload();
        return false
      }
      let formData: any = {
        ...values,
        loginType: loginType
      }

      auth.login(formData)
    }
  })

  /*   useEffect(() => {
      if (loginType == "xero") {
        get("/xeroValues").then((xeroConfig: any) => {
          setXeroCofig({
            YOUR_CALLBACK_URL: xeroConfig.YOUR_CALLBACK_URL,
            YOUR_CLIENT_ID: xeroConfig.YOUR_CLIENT_ID,
            YOUR_REQUEST_STATE: xeroConfig.YOUR_REQUEST_STATE
          })
          const script = document.createElement('script');
          script.src = 'https://edge.xero.com/platform/sso/xero-sso.js';
          script.async = true;
          script.defer = true;
          document.body.appendChild(script);
          return () => {
            document.body.removeChild(script);
          };
        }).catch(() => {
  
        });
      }
    }, []); */
  return (
    <form className='form-horizontal form-login row' onSubmit={loginFrom.handleSubmit}>
      <div className='form-group'>
        <Label className='form-label' htmlFor="userName"> </Label>
        <input
          className="form-control"
          id="userName"
          name="userName"
          placeholder='User Name'
          type="text"
          onChange={loginFrom.handleChange}
          value={loginFrom.values.userName}
        />
        <FormFeedback style={{ display: loginFrom.touched.userName && loginFrom.errors.userName ? 'block' : '' }}>{loginFrom.errors.userName}</FormFeedback>

      </div>
      <div className='form-group'>
        <Label className='form-label' htmlFor="password"></Label>
        <input
          className="form-control"
          id="password"
          name="password"
          placeholder='Password'
          type="password"
          onChange={loginFrom.handleChange}
          value={loginFrom.values.password}
        />
        <FormFeedback style={{ display: loginFrom.touched.password && loginFrom.errors.password ? 'block' : '' }}>{loginFrom.errors.password}</FormFeedback>
      </div>
      <Col lg="12" className='d-flex justify-content-between col-lg-12 gap-2 flex-wrap align-items-start mb-2'>
        <FormGroup check className='d-flex align-items-center gap-2 m-0'>
          <div>
            <Input type="checkbox" id="acceptTerms" className='mb-2' {...loginFrom.getFieldProps('acceptTerms')} checked={loginFrom.values.acceptTerms} />
            <Label check for="check" className='mb-0 ms-1'>
              I Accept <Link to={loginType ? `/${loginType}/terms_conditions` : '/terms_conditions'} state={{ from: "login", loginType }} className=" d-inline-block mx-auto">
                Terms
              </Link> & <Link to={loginType ? `/${loginType}/privacy_policy` : '/privacy_policy'} state={{ from: "login", loginType }} className="d-inline-block mx-auto">
                Privacy
              </Link>
            </Label>
          </div>
        </FormGroup>
        <Link to="/ForgotPassword" className="d-inline-block ">
          Forgot Password
        </Link>
      </Col>
      <Alert color="danger login-alert" style={{ display: loginFrom.touched.acceptTerms && loginFrom.errors.acceptTerms ? 'flex' : 'none' }}>
        {close.icon}
        {loginFrom.errors.acceptTerms}
      </Alert>
      {/* <FormFeedback className='mb-2' style={{ display: loginFrom.touched.acceptTerms && loginFrom.errors.acceptTerms ? 'flex' : '' }}>{loginFrom.errors.acceptTerms}</FormFeedback> */}
      <Col lg="12">
        <Button color='primary' block className="w-100" type="submit">{loading.dataIsLoading ? <Spinner size="sm" /> : 'Submit'}</Button>
      </Col>
      <Col lg="12" className='text-center position-relative'>
        <hr className='mx-4' />
        <span className='or_line'>or</span>
      </Col>
      <Col lg="12" className='text-center'>
        {loginType ? (
          loginType === "xero" ? (
            <>
              <meta charSet="UTF-8" />
              <meta name="xero-client-id" content={xeroCofig.YOUR_CLIENT_ID} />
              <meta name="xero-scopes" content="openid,profile,email" />
              <meta name="xero-redirect-uri" content={xeroCofig.YOUR_CALLBACK_URL} />
              <meta name="xero-state" content={xeroCofig.YOUR_REQUEST_STATE} />
              <span
                data-xero-sso
                data-label="Sign In with Xero"
                onClick={() => {
                  connectToAPP("/singleSignOn", { loginType: loginType }, loading);
                }}
              />
            </>
          ) : loginType === "zoho" ? (
            <>
              <FormGroup className="mb-2">
                <Label for="zohoRegion">Select Region</Label>
                <Input
                  type="select"
                  id="zohoRegion"
                  name="zohoRegion"
                  required
                  onChange={(e) => {
                    setZohoRegion(e.target.value); // save selection
                  }}
                  defaultValue="IN"
                >
                  <option value="US">US (zoho.com)</option>
                  <option value="IN">India (zoho.in)</option>
                  <option value="EU">Europe (zoho.eu)</option>
                  <option value="CA">Canada (zoho.ca)</option>
                  <option value="AU">Australia (zoho.com.au)</option>
                  <option value="UK">UK (zoho.uk)</option>
                  <option value="SA">Saudi Areabia(zoho.sa)</option>
                </Input>
              </FormGroup>
              <Button
                color="primary"
                type="button"
                block
                className="zoho_login py-1"
                onClick={() => {
                  if (window.sessionStorage.getItem("token")) {
                    window.location.reload();
                    return false;
                  }
                  connectToAPP("/singleSignOn", { loginType: "zoho", region: zohoRegion }, loading);
                }}
              >
                {icon} {loading2.dataIsLoading ? <Spinner size="sm" /> : "Zoho Books"}
              </Button>
            </>
          ) : (
            <Button
              type="button"
              block
              className={
                "xero_login py-1 " +
                (loginType === "QBO"
                  ? "qbo_login"
                  : loginType === "zoho"
                    ? "zoho_login"
                    : loginType === "xero"
                      ? "xero_login"
                      : "")
              }
              onClick={() => {
                if (window.sessionStorage.getItem("token")) {
                  window.location.reload();
                  return false;
                }
                connectToAPP("/singleSignOn", { loginType: loginType }, loading);
              }}
            >
              {icon} {loading2.dataIsLoading ? <Spinner size="sm" /> : loginType + " Login"}
            </Button>
          )
        ) : (
          <></>
        )}
      </Col>

      <Col lg="12" className='text-center' hidden={loginType == "zoho" ? true : false}>Don’t have an account?
        <Link to={loginType ? `/${loginType}/signUp` : '/signUp'} className="pt-3 d-inline-block mx-auto ps-2">
          Create an account
        </Link>
      </Col>




    </form >
  )

}

export default Login